














































import { Vue, Component } from "vue-property-decorator"
import sideBar from "./components/sideBar/index.vue"
import UserMenu from "@/components/userMenu/index.vue"
import UserService from "@/services/user.service"
import { mapGetters, mapActions } from "vuex"
import config from "@/config"
@Component({
    components: {
        sideBar,
        UserMenu
    },
    computed: {
        ...mapGetters(["isCollapse", "version"])
    },
    methods: {
        ...mapActions("user", ["loginOut"])
    }
})
export default class Admin extends Vue {
    isCollapse!: boolean
    width = "220px"
    title = process.env.VUE_APP_MENU_NAME
    get key() {
        return this.$route.name !== undefined
            ? this.$route.name
            : this.$route.toString() + new Date()
    }
    readonly keepAlives = [
        "VersionList", //版本列表
        "ProductList", //产品列表
        "AigcList", //AIGC功能列表
        "PolicyList", //隐私政策
        "ContrastList" //产品与隐私政策相关对照列表
    ]
    toggleSideBar() {
        this.$store.commit("app/setIsCollapse", !this.isCollapse)
    }

    backHome() {
        this.$router.push({
            path: "/home"
        })
    }

    //getUserBaseInfo
    async getUserBaseInfo() {
        return await UserService.getUserBaseInfo()
    }

    toPersonal() {
        const url =
            config.env === "online"
                ? "https://home.intsig.net/personalInfo/info"
                : "https://home-sandbox.intsig.net/personalInfo/info"
        window.location.href = url
    }

    getPopupContainer(triggerNode: any, dialogContext: any) {
        if (dialogContext) {
            const wrap = dialogContext.getDialogWrap()
            const body = wrap.querySelector(".ant-modal-body")
            if (parseInt(getComputedStyle(body).height) < 300) {
                return wrap
            }
            if (triggerNode) {
                const parentNode = triggerNode.parentNode
                if (parentNode.clientWidth > 150) {
                    // parentNode 足够塞下popover
                    return triggerNode.parentNode
                }
            }
            return body
        }
        return document.querySelector(".router-view")
    }
}
